// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","iconLink":"iconLink_FmOjC","iconLinkText":"iconLinkText_L9BEm","iconLinkIcon":"iconLinkIcon_JNW9D"};